import React, { FC } from 'react';

import { Error, ErrorWrapper, Icon, Info, Success } from './toast.styled';
import { ToastType } from './types';

export const ToastTypeLogo: FC<{ type: ToastType }> = ({ type }) => {
  switch (type) {
    case 'success':
      return (
        <Icon>
          <Success isActive />
        </Icon>
      );
    case 'info':
    case 'default':
      return (
        <Icon>
          <Info>!</Info>
        </Icon>
      );
    case 'warning':
    case 'error':
      return (
        <Icon>
          <ErrorWrapper>
            <Error />
          </ErrorWrapper>
        </Icon>
      );
    default:
      return null;
  }
};
